export default function getApiErrorCode(error: any) {
  const axiosResponse = error.response;
  return axiosResponse ? axiosResponse.data.name || axiosResponse.data.statusCode : undefined;
}

export class RCUIDUserNotRegister extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'RCUIDUserNotRegister';
  }
}

